import GeoInsightsPanel, {
  InsightBlock
} from '@/components/container/modules/mediaGeo/common/GeoInsightsPanel'

interface Props {
  strengths: string[]
  concerns: string[]
  // 改善提案。複数件は1つの改善案としてまとめて表示する
  suggestions: string[]
}

// インサイト（強み・懸念点・AIの改善案）
const SentimentInsightsPanel = ({ strengths, concerns, suggestions }: Props) => {
  const blocks: InsightBlock[] = [
    ...(strengths.length > 0
      ? [{ title: '強み', tone: 'positive' as const, texts: strengths }]
      : []),
    ...(concerns.length > 0
      ? [{ title: '懸念点', tone: 'negative' as const, texts: concerns }]
      : [])
  ]

  return <GeoInsightsPanel blocks={blocks} recommendation={suggestions.join(' ') || null} />
}

export default SentimentInsightsPanel
